import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceincyberabadhyderabad() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Cyberabad Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Cyberabad Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Cyberabad Hyderabad, catering to the transportation needs of IT parks, corporate offices, and business centers in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Cyberabad Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
{
"name": "Cyberabad Corporate Shuttle",
"description": "Cyberabad Corporate Shuttle provides high-capacity, tech-enabled shuttle services for IT parks, SEZs, and corporate campuses across Cyberabad. With AC minibuses, optimized multi-route planning, real-time tracking, and automated attendance systems, it ensures smooth, safe, and timely mass employee transportation. Ideal for large IT companies and corporate parks, it supports multi-shift travel and peak-hour mobility with seamless coordination."
},
{
"name": "Employee Transport Cyberabad",
"description": "Employee Transport Cyberabad offers structured end-to-end mobility solutions for employees working across Cyberabad’s major business zones. With GPS monitoring, fixed and flexible routes, verified chauffeurs, and shift-aligned scheduling, it enables safe, reliable, and comfortable daily commuting for all workforce categories."
},
{
"name": "Business Cab Cyberabad",
"description": "Business Cab Cyberabad provides premium travel services for executives, client visits, airport transfers, and inter-office travel. The fleet includes modern sedans and SUVs operated by trained corporate chauffeurs, ensuring punctuality, comfort, and a refined travel experience suitable for professional engagements."
},
{
"name": "Staff Pickup Drop Cyberabad",
"description": "Staff Pickup Drop Cyberabad ensures dependable, well-planned employee pickups and drops with pre-defined routes, trained drivers, and real-time tracking. Ideal for IT, corporate, and BPO employees, the service ensures punctual and safe travel across all shifts within Cyberabad’s business districts."
},
{
"name": "IT Park Cab Cyberabad",
"description": "IT Park Cab Cyberabad delivers specialized employee transportation tailored for major tech parks across Cyberabad. With optimized routing, digital scheduling, GPS supervision, and strict safety compliance, it ensures efficient daily mobility for IT professionals working in high-density technology corridors."
},
{
"name": "Monthly Cab Cyberabad",
"description": "Monthly Cab Cyberabad offers contract-based corporate cab services with dedicated vehicles, trained drivers, assured availability, and ongoing maintenance included. Ideal for companies seeking reliable long-term commuting solutions, it supports executive mobility as well as employee travel with predictable and affordable monthly plans."
},
{
"name": "Best Corporate Cab Cyberabad",
"description": "Best Corporate Cab Cyberabad provides top-quality vehicles, highly trained chauffeurs, and premium safety standards designed for senior executives and VIP travel. Offering first-class comfort and punctuality, it is suited for board meetings, high-profile visits, airport transfers, and executive commuting requirements."
},
{
"name": "Affordable Cab Cyberabad",
"description": "Affordable Cab Cyberabad delivers cost-effective mobility solutions for startups, SMEs, and mid-sized IT firms. With efficient routing, clean vehicles, experienced drivers, and transparent pricing, it ensures dependable daily commuting without compromising on quality or safety."
},
{
"name": "Outstation Cab Cyberabad",
"description": "Outstation Cab Cyberabad provides well-managed long-distance corporate travel for business meetings, factory visits, intercity client interactions, and executive tours. With comfortable vehicles, interstate permits, experienced chauffeurs, and real-time tracking, it ensures safe, smooth, and reliable outstation journeys."
},
{
"name": "Sedan Cab Cyberabad",
"description": "Sedan Cab Cyberabad offers executive-friendly sedans ideal for business meetings, airport rides, everyday office commute, and corporate travel. Featuring plush interiors, well-maintained vehicles, and trained drivers, this service ensures a comfortable, quiet, and premium travel experience."
},
{
"name": "SUV Cab Cyberabad",
"description": "SUV Cab Cyberabad delivers spacious SUVs perfect for senior executive travel, long-distance business drives, team movement, and high-comfort commuting. With professional chauffeurs, GPS monitoring, and well-maintained vehicles, it ensures a smooth and premium journey experience."
},
{
"name": "Company Fleet Cyberabad",
"description": "Company Fleet Cyberabad provides fully managed fleet outsourcing solutions including sedans, SUVs, employee shuttles, and staff cabs. With driver management, maintenance coverage, compliance tracking, and tech-enabled fleet monitoring, it helps companies streamline and scale their transportation operations effortlessly."
},
{
"name": "Office Cab Cyberabad",
"description": "Office Cab Cyberabad offers standardized daily office commute services with fixed routes, real-time tracking, shift-based deployment, and professional drivers. Designed for corporate offices, IT firms, and BPOs, it ensures reliable, safe, and punctual mobility for employees across Cyberabad."
},
{
"name": "Employee Mobility Cyberabad",
"description": "Employee Mobility Cyberabad provides comprehensive workforce transportation solutions including daily commute, shuttle operations, on-demand cabs, and long-term fleet deployment. It focuses on safety, punctuality, route optimization, and tech-driven monitoring to support seamless employee movement across Cyberabad."
},
{
"name": "Corporate Taxi Cyberabad",
"description": "Corporate Taxi Cyberabad offers quick-response, professionally managed taxi services for executives, employees, and business travellers. With instant dispatch, modern vehicles, trained chauffeurs, and strong safety protocols, it ensures reliable corporate mobility for meetings, visits, and everyday travel needs."
}
],

"tableData": [
["Cyberabad Corporate Shuttle", "Employee Transport Cyberabad"],
["Business Cab Cyberabad", "Staff Pickup Drop Cyberabad"],
["IT Park Cab Cyberabad", "Monthly Cab Cyberabad"],
["Best Corporate Cab Cyberabad", "Affordable Cab Cyberabad"],
["Outstation Cab Cyberabad", "Sedan Cab Cyberabad"],
["SUV Cab Cyberabad", "Company Fleet Cyberabad"],
["Office Cab Cyberabad", "Employee Mobility Cyberabad"],
["Corporate Taxi Cyberabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Cyberabad Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Cyberabad Hyderabad, ensuring smooth and efficient transportation for employees and business executives across the IT corridor."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure on-time pickups and drop-offs throughout Cyberabad’s IT parks, corporate offices, and commercial hubs, helping employees reach work and meetings on schedule."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs offer safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from a wide variety of sedans, SUVs, tempo travellers, and buses—each sanitized, serviced, and maintained for dependable corporate travel in Cyberabad."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible, scalable, and tailored corporate cab rental plans that fit the unique commuting requirements of companies and employees in Cyberabad Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Travel Support",
    "WhyChoosedescription": "Our round-the-clock support team handles bookings, travel adjustments, and urgent corporate transportation needs to ensure seamless travel operations."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering clean, safe, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination simplify employee transportation management for HR and admin teams."
  }
]








































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Cyberabad, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dependable and professional corporate cab services for companies operating in the Cyberabad region of Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Cyberabad?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and complete fleet management solutions for tech parks and business centres.',
  },
  {
    question: 'Do you support daily employee commute services in Cyberabad?',
    answer: 'Yes, we offer well-structured daily commute services with efficient route planning, punctual pickups, and multi-shift support.',
  },
  {
    question: 'How can companies book corporate cab services in Cyberabad?',
    answer: 'Bookings can be done through our website, mobile application, or by contacting our 24×7 dedicated corporate support desk.',
  },
  {
    question: 'Which vehicles do you provide for corporate cab services in Cyberabad?',
    answer: 'We offer sedans, hatchbacks, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs tailored to corporate needs.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for Cyberabad clients?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with complete fleet management and transparent pricing.',
  },
  {
    question: 'Are safety and GPS tracking included in your corporate cab services?',
    answer: 'All our vehicles are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you support night shift employee transportation in Cyberabad?',
    answer: 'Absolutely. We offer reliable transportation solutions for night shifts, early morning shifts, rotational schedules, and weekend operations.',
  },
  {
    question: 'What payment modes do you support for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Chintapalli',
    feedback: 'Excellent corporate cab service in Cyberabad. Drivers are punctual, vehicles are clean, and the coordination is seamless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Haritha Muppidi',
    feedback: 'Very professional service. Our employees rely on their timely transportation and appreciate the well-maintained fleet.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Cyberabad Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-cyberabad.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Cyberabad Hyderabad, offering employee transportation, IT park cab services, business travel cabs, staff pickup & drop, corporate shuttle services, monthly corporate cab rentals, and outstation travel solutions for companies in Cyberabad.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-cyberabad-hyderabad"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Cyberabad Hyderabad | Employee & IT Park Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Cyberabad Hyderabad including employee transport, staff pickup & drop, business taxi services, IT park cab service, corporate shuttles, monthly rentals, and affordable outstation cabs."
  />

  <meta
    name="keywords"
    content="Cyberabad Corporate Shuttle, Employee Transport Cyberabad, Business Cab Cyberabad, Staff Pickup Drop Cyberabad, IT Park Cab Cyberabad, Monthly Cab Cyberabad, Best Corporate Cab Cyberabad, Affordable Cab Cyberabad, Outstation Cab Cyberabad, Sedan Cab Cyberabad, SUV Cab Cyberabad, Company Fleet Cyberabad, Office Cab Cyberabad, Employee Mobility Cyberabad, Corporate Taxi Cyberabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceincyberabadhyderabad;